export default __webpack_public_path__ + "static/media/EyeClosed.bb48f3f9.svg";